'use client';

import { useCallback } from 'react';
import { Keypair } from '@solana/web3.js';
import { Wallet } from '@velocity-exchange/sdk';
import useDriftStore from 'src/stores/DriftStore/useDriftStore';
import useDriftAccountsStore from 'src/stores/useDriftAccountsStore';
import { notify } from 'src/utils/notifications';
import useDriftClient from '../useDriftClient';

const useWalletDisconnect = () => {
	const driftClient = useDriftClient();

	const set = useDriftStore((s) => s.set);
	const resetAccountsState = useDriftAccountsStore((s) => s.resetAccountsState);

	const handleWalletDisconnect = useCallback(() => {
		notify({
			id: 'wallet_disconnection',
			type: 'success',
			message: 'Disconnected from wallet',
			updatePrevious: true,
		});

		set((s) => {
			s.wallet.currentPublicKeyString = null;
			s.wallet.isMagicAuth = false;
			s.wallet.isAppKit = false;
			s.wallet.isPrivyNativeAuth = false;
		});

		driftClient?.updateWallet(new Wallet(new Keypair()));

		resetAccountsState();
	}, [set, resetAccountsState, driftClient]);

	return {
		handleWalletDisconnect,
	};
};

export default useWalletDisconnect;
